export const formatLookthroughClasses = (walletAnalysis) => {
  const empty = { hasComposition: false, classesWithComposition: [] }
  const composicao = walletAnalysis && walletAnalysis.composicao_fundos
  if (!composicao || typeof composicao !== 'object') return empty
  const groups = Object.values(composicao)
  if (groups.length === 0) return empty

  const classes = new Set()
  groups.forEach((groupAssets) => {
    if (!Array.isArray(groupAssets)) return
    groupAssets.forEach((ativo) => {
      if (!ativo) return
      if (ativo.classe) classes.add(ativo.classe)
      if (ativo.subclasse) classes.add(ativo.subclasse)
    })
  })

  return {
    hasComposition: classes.size > 0,
    classesWithComposition: [...classes],
  }
}
